import { useEffect, useState } from 'react';
import { getTrailTally } from '../services/miceTrailService';

/** Live count of mice found and still hiding in the current town. */
export default function useTrailTally() {
  const [tally, setTally] = useState(null);

  useEffect(() => {
    let live = true;
    const load = () => {
      getTrailTally()
        .then((next) => { if (live) setTally(next); })
        .catch(() => {});
    };
    load();
    const timer = setInterval(load, 60000);
    return () => {
      live = false;
      clearInterval(timer);
    };
  }, []);

  return tally;
}
